/* B3 Loghi con intestazione — riempimento della traccia e comparsa allo scroll.

   Lo scorrimento è un'animazione CSS su due metà identiche stampate dal server
   (stessa tecnica di b3-marquee-loghi, e stesso motivo per cui non si riusa
   marquee-component: la sua durata dipende dal numero di copie e la pausa al
   passaggio del mouse è cablata dentro il componente). Qui il JS fa due cose:

   1. moltiplica le copie dentro ciascuna metà quando le tessere non riempiono
      lo schermo, ma solo se al breakpoint corrente la modalità è "scorre";
   2. accende la comparsa allo scroll. Lo stato nascosto viene scritto da qui:
      se questo file non parte, il contenuto resta visibile. */
(function () {
  var MAX_COPIE = 10;
  var SICUREZZA = 2500;

  function scorreOra(root) {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    return (mobile ? root.dataset.mobile : root.dataset.desktop) === 'scorre';
  }

  function riempi(root) {
    var viewport = root.querySelector('[data-b3-loghi-viewport]');
    var meta = root.querySelectorAll('[data-b3-loghi-meta]');
    if (!viewport || meta.length < 2) return;

    var i;
    /* Alla prima passata si mette da parte il contenuto originale di ogni
       metà: le passate successive ripartono da lì invece di accumulare. */
    for (i = 0; i < meta.length; i++) {
      if (!meta[i].b3Originale) {
        meta[i].b3Originale = Array.prototype.map.call(meta[i].children, function (figlio) {
          return figlio.cloneNode(true);
        });
      }
    }

    var copie = 1;
    if (scorreOra(root)) {
      var larghezzaViewport = viewport.clientWidth;
      var larghezzaMeta = meta[0].scrollWidth;
      if (!larghezzaViewport || !larghezzaMeta) return;
      copie = Math.ceil(larghezzaViewport / larghezzaMeta);
      if (copie < 1) copie = 1;
      if (copie > MAX_COPIE) copie = MAX_COPIE;
    }

    if (String(copie) === root.dataset.copie) return;
    root.dataset.copie = String(copie);

    for (var m = 0; m < meta.length; m++) {
      var originale = meta[m].b3Originale;
      var frammento = document.createDocumentFragment();
      for (var c = 0; c < copie; c++) {
        for (var k = 0; k < originale.length; k++) {
          frammento.appendChild(originale[k].cloneNode(true));
        }
      }
      meta[m].textContent = '';
      meta[m].appendChild(frammento);
    }
  }

  function preparaComparsa(root) {
    if (root.dataset.anima !== 'si') return null;

    /* I ritardi si assegnano PRIMA di riempi(): così finiscono anche nelle
       copie clonate, che ripetono la stessa sequenza invece di comparire
       tutte insieme. */
    var passo = 0;
    var ritardo = 120;

    var testate = root.querySelectorAll('[data-b3-anima]');
    for (var i = 0; i < testate.length; i++) {
      testate[i].style.setProperty('--b3-loghi-ritardo', passo * ritardo);
      passo += 1;
    }

    var voci = root.querySelectorAll('.b3-loghi__voce');
    for (var j = 0; j < voci.length; j++) {
      voci[j].style.setProperty('--b3-loghi-ritardo', (passo + j) * 60);
    }

    return true;
  }

  function initLoghi(root) {
    if (root.dataset.loghiInit === 'true') return;
    root.dataset.loghiInit = 'true';

    var motoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!motoRidotto && preparaComparsa(root)) {
      /* Da qui in poi il CSS nasconde: si accende solo ora, a un passo dal
         rivelare. */
      root.dataset.b3Anim = 'pronto';

      var fatto = false;
      var rivela = function () {
        if (fatto) return;
        fatto = true;
        root.dataset.b3Anim = 'dentro';
      };

      /* Nel theme editor la sezione viene ricostruita a ogni modifica e non si
         può chiedere all'utente di scorrere: si rivela al frame dopo. */
      if ((window.Shopify && window.Shopify.designMode) || typeof IntersectionObserver === 'undefined') {
        requestAnimationFrame(rivela);
      } else {
        var osservatore = new IntersectionObserver(
          function (voci) {
            for (var i = 0; i < voci.length; i++) {
              if (voci[i].isIntersecting) {
                osservatore.disconnect();
                rivela();
                return;
              }
            }
          },
          { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
        );
        osservatore.observe(root);

        /* Se l'osservatore non scattasse, il contenuto non resta nascosto. */
        setTimeout(function () {
          if (!fatto) {
            osservatore.disconnect();
            rivela();
          }
        }, SICUREZZA);
      }
    }

    if (motoRidotto) return;

    /* Le immagini sono lazy: la larghezza reale si conosce a caricamento
       avvenuto, quindi si ricalcola anche dopo. */
    riempi(root);
    window.addEventListener('load', function () {
      riempi(root);
    });

    var attesa = null;
    window.addEventListener('resize', function () {
      clearTimeout(attesa);
      attesa = setTimeout(function () {
        riempi(root);
      }, 200);
    });
  }

  function init() {
    document.querySelectorAll('[data-b3-loghi]').forEach(initLoghi);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-b3-loghi]') : null;
    if (root) {
      root.dataset.loghiInit = '';
      root.dataset.copie = '';
      initLoghi(root);
    }
  });
})();
